import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "admin-primary-nav",
  "aria-label": "一级分类"
};
const _hoisted_2 = {
  class: "admin-group-list"
};
const _hoisted_3 = ["aria-pressed", "onClick"];
const _hoisted_4 = ["aria-label", "aria-expanded"];
const _hoisted_5 = {
  id: "admin-secondary-navigation",
  class: "admin-secondary-panel"
};
const _hoisted_6 = {
  class: "admin-secondary-heading"
};
const _hoisted_7 = {
  class: "admin-child-list"
};
const _hoisted_8 = ["aria-current", "onClick"];
const _hoisted_9 = {
  key: 0,
  class: "admin-menu-empty"
};
import { computed, ref, watch } from 'vue';

// 菜单来自登录缓存；当前页面与所属分类由布局传入，组件不修改菜单数据。

export default {
  __name: 'AdminSidebar',
  props: {
    menus: {
      type: Array,
      default: () => []
    },
    activeMenu: {
      type: String,
      default: ''
    },
    activeGroup: {
      type: String,
      default: ''
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select', 'update:collapsed'],
  setup(__props, {
    emit: __emit
  }) {
    /** 后台双列菜单：负责分类切换、二级导航和折叠交互，路由跳转由布局处理。 */
    const props = __props;
    // 二级菜单选择交由布局导航，折叠状态通过 v-model 同步。
    const emit = __emit;
    // 用户正在浏览的一级分类，切换分类时保留当前页面。
    const selectedGroupId = ref('');

    /**
     * 统一菜单标识，兼容菜单接口返回数字或字符串 ID。
     * @param {Object | null} menu - 菜单项，空值表示未选中
     * @returns {String} 菜单标识，空项返回空字符串
     */
    const getMenuId = menu => String(menu?.menuId ?? menu?.id ?? '');

    // 保留现有可见分类规则，并按配置排序组装对应二级菜单。
    const menuGroups = computed(() => props.menus.filter(menu => !menu.parentId || String(menu.parentId) === '0').filter(menu => (menu.name || menu.menuName) !== '欢迎').map(menu => ({
      ...menu,
      children: props.menus.filter(child => String(child.parentId ?? '') === getMenuId(menu)).sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
    })).filter(menu => menu.children.length).sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0)));
    // 当前浏览分类缺失时回退到第一个可用分类。
    const selectedGroup = computed(() => menuGroups.value.find(menu => getMenuId(menu) === selectedGroupId.value) || menuGroups.value[0]);
    // 右列仅展示当前分类下的二级菜单。
    const selectedChildren = computed(() => selectedGroup.value?.children || []);

    /**
     * 页面或菜单数据变化时同步分类，支持刷新和浏览器前进、后退。
     * @param {Array} values - 当前二级菜单、所属分类及可见分类列表
     */
    const syncActiveGroup = ([, groupId]) => {
      const activeGroup = menuGroups.value.find(menu => getMenuId(menu) === groupId);
      if (activeGroup) {
        selectedGroupId.value = groupId;
      } else if (!menuGroups.value.some(menu => getMenuId(menu) === selectedGroupId.value)) {
        selectedGroupId.value = getMenuId(menuGroups.value[0]);
      }
    };
    watch([() => props.activeMenu, () => props.activeGroup, menuGroups], syncActiveGroup, {
      immediate: true
    });

    /**
     * 切换一级分类，并在右列收起时展开对应二级菜单。
     * @param {Object} group - 用户选择的一级分类
     */
    const selectGroup = group => {
      selectedGroupId.value = getMenuId(group);
      if (props.collapsed) emit('update:collapsed', false);
    };

    /**
     * 分发二级菜单选择，小屏幕导航完成后收起右列以保留内容空间。
     * @param {Object} menu - 用户选择的二级菜单
     */
    const selectMenu = menu => {
      emit('select', getMenuId(menu));
      if (window.matchMedia('(max-width: 767px)').matches) emit('update:collapsed', true);
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_Expand = _resolveComponent("Expand");
      const _component_Fold = _resolveComponent("Fold");
      return _openBlock(), _createElementBlock("aside", {
        class: _normalizeClass(["admin-sidebar", {
          'is-collapsed': __props.collapsed
        }]),
        "aria-label": "后台导航"
      }, [_createElementVNode("nav", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "admin-nav-caption"
      }, "工作导航", -1)), _createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuGroups.value, group => {
        return _openBlock(), _createElementBlock("li", {
          key: getMenuId(group)
        }, [_createElementVNode("button", {
          class: _normalizeClass(["admin-group-button", {
            'is-active': getMenuId(selectedGroup.value) === getMenuId(group)
          }]),
          type: "button",
          "aria-pressed": getMenuId(selectedGroup.value) === getMenuId(group),
          "aria-controls": "admin-secondary-navigation",
          onClick: $event => selectGroup(group)
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(group.icon || 'Menu')))]),
          _: 2
        }, 1024), _createElementVNode("span", null, _toDisplayString(group.name || group.menuName), 1)], 10, _hoisted_3)]);
      }), 128))]), _createElementVNode("button", {
        class: "admin-sidebar-toggle",
        type: "button",
        "aria-label": __props.collapsed ? '展开二级菜单' : '收起二级菜单',
        "aria-expanded": !__props.collapsed,
        "aria-controls": "admin-secondary-navigation",
        onClick: _cache[0] || (_cache[0] = $event => emit('update:collapsed', !__props.collapsed))
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [__props.collapsed ? (_openBlock(), _createBlock(_component_Expand, {
          key: 0
        })) : (_openBlock(), _createBlock(_component_Fold, {
          key: 1
        }))]),
        _: 1
      }), _createElementVNode("span", null, _toDisplayString(__props.collapsed ? '展开' : '收起'), 1)], 8, _hoisted_4)]), _withDirectives(_createElementVNode("section", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(selectedGroup.value?.name || selectedGroup.value?.menuName || '功能菜单'), 1), (_openBlock(), _createElementBlock("nav", {
        key: getMenuId(selectedGroup.value),
        class: "admin-secondary-nav",
        "aria-label": "二级菜单"
      }, [_createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedChildren.value, menu => {
        return _openBlock(), _createElementBlock("li", {
          key: getMenuId(menu)
        }, [_createElementVNode("button", {
          class: _normalizeClass(["admin-child-button", {
            'is-active': __props.activeMenu === getMenuId(menu)
          }]),
          type: "button",
          "aria-current": __props.activeMenu === getMenuId(menu) ? 'page' : undefined,
          onClick: $event => selectMenu(menu)
        }, _toDisplayString(menu.name || menu.menuName), 11, _hoisted_8)]);
      }), 128))]), !selectedChildren.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_9, "暂无可用菜单")) : _createCommentVNode("", true)]))], 512), [[_vShow, !__props.collapsed]])], 2);
    };
  }
};